import axios from 'axios';
import { Controller } from '@hotwired/stimulus';
import { createCifraVueApp } from '..';

// No recuerdo por qué no es un componente VUE normal...
// Debemos hacer un componente normal para quitar esta creación
export default class extends Controller {
  connect() {
    const rootElement = document.getElementById('selector-usuario');

    this.app = createCifraVueApp({
      // truco para pasarle todos los elementos data del raíz como propiedades del componente
      propsData: { ...rootElement.dataset },
      props: {
      },
      data() {
        return {
          ultimosEstudios: null,
        };
      },
      methods: {
        usuarioSeleccionado(idUsuario) {
          axios.get(`/reserva_plazas/info_alumno/${idUsuario}`).then((result) => {
            this.ultimosEstudios = result.data.ultimos_estudios;
          });
        },
      },
    });
    this.app.mount(rootElement);
  }
}
